__turbopack_context__.v({
  "heroBanner": "careers-hero-banner-module-scss-module__GGEEBq__heroBanner",
  "heroBanner--DeepBlue": "careers-hero-banner-module-scss-module__GGEEBq__heroBanner--DeepBlue",
  "heroBanner--equalWidth": "careers-hero-banner-module-scss-module__GGEEBq__heroBanner--equalWidth",
  "heroBanner--imagePosition": "careers-hero-banner-module-scss-module__GGEEBq__heroBanner--imagePosition",
  "imageContent": "careers-hero-banner-module-scss-module__GGEEBq__imageContent",
  "textContent": "careers-hero-banner-module-scss-module__GGEEBq__textContent",
  "textContent--design-2": "careers-hero-banner-module-scss-module__GGEEBq__textContent--design-2",
});
